import React from 'react';
import type { GamificationEventsSummary, GamificationPeriod } from '@troia-v3/types';

import { Switch } from '@/shared/components/ui';
import { periodThisLabel } from '@/shared/utils/gamificationPeriod';

import { SettingsSection } from './SettingsSection';

interface Props { enabled: boolean; onChange: (v: boolean) => void; summary?: GamificationEventsSummary; period?: GamificationPeriod; disabled?: boolean }

/** "Ativação" — liga/desliga a gamificação para toda a empresa (linha de toggle no padrão do form de canal). O "neste mês" acompanha o período configurado. */
export const ActivationSection: React.FC<Props> = ({ enabled, onChange, summary, period = 'month', disabled = false }) => {
  const since = summary?.firstConfirmedAt ? new Date(summary.firstConfirmedAt).toLocaleDateString('pt-BR') : null;
  return (
    <SettingsSection icon="settings" title="Ativação" description="Liga e desliga a pontuação e os rankings para toda a empresa. Desligar não apaga o histórico." testId="gamification-section-activation">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <label htmlFor="gamification-enabled" className="block text-sm font-medium mb-1" style={{ color: 'var(--theme-card-text)' }}>
            {enabled ? 'Gamificação ativa' : 'Gamificação desligada'}
          </label>
          <p className="text-xs" style={{ color: 'var(--theme-card-muted)' }}>
            {since ? `Pontuando desde ${since} · ` : 'Ainda sem pontos confirmados · '}
            {new Intl.NumberFormat('pt-BR').format(summary?.confirmedPoints ?? 0)} pontos confirmados {periodThisLabel(period)}
          </p>
        </div>
        <Switch id="gamification-enabled" checked={enabled} onChange={onChange} disabled={disabled} aria-label="Gamificação ativa" data-testid="gamification-enabled-switch" />
      </div>
    </SettingsSection>
  );
};
ActivationSection.displayName = 'ActivationSection';
